<template>
  <span v-if="text">
    <span class="text-trimmed">{{ textTrimmed }}</span>
    <button v-if="tooLong" @click="toggleTextExpand" type="button" class="slo-text-collapse-button">
      {{ expanded ? 'less' : 'more...' | t }}
    </button>
  </span>
</template>

<script>
import t from '../../js/main/i18n';

export default {
  name: 'SloTextCollapse',
  filters: {
    t
  },
  data() {
    return {
      expanded: false
    };
  },
  props: {
    text: {type: String, required: true},
    maxLength: {type: Number, default: 200}
  },
  computed: {
    textTrimmed() {
      return !this.expanded ? this.text.substring(0, this.maxLength) : this.text;
    },
    tooLong() {
      return this.text.length > this.maxLength;
    }
  },
  methods: {
    toggleTextExpand() {
      this.expanded = !this.expanded;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../scss/variables';
@import '../../scss/system';

.slo-text-collapse-button {
  padding: 0;
  background-color: transparent;
  border: none;
  color: $color-blue-400;
  margin-bottom: 2px;

  &:hover, &:focus {
    color: $color-blue-700;
  }
}
</style>
